import { render, staticRenderFns } from "./cognition_staff.vue?vue&type=template&id=9aad3096&scoped=true"
import script from "./cognition_staff.vue?vue&type=script&lang=js"
export * from "./cognition_staff.vue?vue&type=script&lang=js"
import style0 from "./cognition_staff.vue?vue&type=style&index=0&id=9aad3096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aad3096",
  null
  
)

export default component.exports